export const trading = {
  kpsj: "Время открытия",
  jlks: "До начала",
  t: "дн.",
  s: "ч",
  f: "мин",
  m: "сек",

  zgj: "Максимум:",
  zdj: "Минимум:",
  gflj: "Официальные ссылки",
  gw: "Веб-сайт",
  qkllq: "Обозреватель блоков",
  scfxsj: "Дата первого выпуска",
  fxzl: "Общий объём эмиссии",
  ltzl: "Циркулирующий объём",
  jy: "Торговля",
  sj: "Рыночная",
  tbxx: "Информация на графике",
  bzgk: "Обзор монеты",
  jcb: "Базовая версия",
  ddb: "Книга ордеров",
  zxcj: "Последние сделки",

  reload: "Обновить",
  socketError: "Ошибка сети,",
  noData: "Нет данных",
  entrustorder: "Стакан",
  prices: "Цена",
  quantity: "Количество",
  grandtotal: "Накоплено",
  transamount: "Объём",
  time: "Время",
  available: "Доступно",
  limitorder: "Лимитный",
  plancommission: "Условный ордер",
  currentcommission: "Активные",
  historycommission: "История ордеров",
  completecommission: "Исполненные",
  funds: "Средства",
  hidetrading: "Скрыть другие пары",
  morecurrentcommission: "Больше активных ордеров",
  morehistorycommission: "Больше истории ордеров",
  moredocommission: "Больше исполненных ордеров",
  realtimetrans: "Сделки в реальном времени",
  myassets: "Мои активы",
  detail: "Детали",
  buyin: "Купить",
  sellout: "Продать",
  login: "Войти",
  transfer: "Перевести",
  recharge: "Пополнить",
  withdrawal: "Вывести",
  quickpurchase: "Быстрая покупка за фиат",
  default: "По умолчанию",
  ordertime: "Время ордера",
  tradingpair: "Торговая пара",
  direction: "Направление",
  types: "Тип",
  commissionprice: "Цена ордера",
  commissionnumber: "Количество в ордере",
  dealprice: "Средняя цена исполнения",
  dealnumber: "Исполненное количество",
  triggerprice: "Цена активации",
  cancelall: "Отменить все",
  averageprice: "Средняя цена",
  totalsum: "Итого",
  fixedprice: "Лимит",
  marketprice: "Рынок",
  codeExpired: "QR-код устарел",
  clickRefresh: "Нажмите для обновления",
  QRsuccessfully: "Сканирование успешно",
  loginInApp: "Пожалуйста, подтвердите вход в приложении",
  backtoQR: "Вернуться к QR-коду",
  loginSuccess: "Вы успешно вошли! Добро пожаловать в Biking!",
  loadingText: "Загрузка...",
  searchPlaceholder: "Поиск",
  all: "Все",
  currency: "Монета",
  price: "Последняя цена",
  market: "Рейтинг роста",
  increase: "Изменение",
  highestPrice: "Максимум",
  minimumPrice: "Минимум",
  turnover: "Объём",
  jydlb: "Список торговых пар",
  bzjs: "Описание монеты",
  currencyTransaction: "Спот",
  leveragedTransaction: "Маржинальная торговля",
  warning:
    "Предупреждение: хардфорк Bitcoin Cash влечёт высокую неопределённость и риски. BiKing не даёт никаких гарантий стоимости форк-токенов!",
  zb: "Индикатор",
  date: "Дата",
  UpAnddown: "Рост/падение",
  amplitude: "Амплитуда",
  0: "Таймфрейм",
  1: "1 мин",
  5: "5 мин",
  15: "15 мин",
  30: "30 мин",
  60: "1 ч",
  240: "4 ч",
  3600: "1 день",
  10800: "1 неделя",
  dates: "Период:",
  password: "Торговый пароль",
  errorPassword: "Введите правильный пароль",
  worningPassword: "Введите пароль",
  cancel: "Отмена",
  sure: "Подтвердить",
  canBuy: "Доступно для покупки",
  canCell: "Доступно для продажи",
  withdraw: "Вывести",
  otc: "OTC — быстрый вход/выход за фиат",
  enterPrice: "Введите цену",
  sellingPrice: "Цена продажи",
  purchasePrice: "Цена покупки",
  salesVolume: "Объём продажи",
  buyingVolume: "Объём покупки",
  volume: "Объём сделки",
  serviceCharge: "Комиссия",
  vip: "VIP — скидка на комиссию",
  or: "или",
  register: "Регистрация",
  totalPrice: "Объём сделки не может превышать",
  amountTip: "Введите корректное количество",
  amountTipError: "Количество не может превышать",
  limitTrading: "Лимитная торговля",
  priceReminder: "Напоминание о цене",
  SMSReminder: "SMS-уведомление",
  loginAccount: "Войти",
  phone: "Телефон",
  phoneNum: "Введите номер телефона",
  phoneTips: "Неверный номер",
  email: "Эл. почта",
  emailNum: "Введите email",
  emailTips: "﻿Неверный email",
  aears: "Выберите код страны",
  passwordError: "Введите правильный пароль",
  passwordTips: "Введите пароль",
  forgetPassword: "Забыли пароль?",
  noAccount: "Нет аккаунта?",
  goRegister: "Зарегистрироваться",
  appsys: "Вход по QR-коду (безопасно)",
  xzapp: "Скачать последнюю версию приложения",
  mmdl: "Вход по паролю",
  smdl: "Вход по QR-коду",
  google: "Google Authenticator",
  nybd: "Вы привязали",
  zqyzm: "Введите корректный код",
  fsyzm: "Отправить код",
  flv: "Комиссия",
  jz: "Стоимость чистых активов (NAV)",
  jzdesc1:
    "NAV (лонг) = NAV(пред.корр.) * [1 + 3 * (тек.спот цена - пред.спот цена) / пред.спот цена * 100%]",
  jzdesc2:
    "NAV (шорт) = NAV(пред.корр.) * [1 - 3 * (тек.спот цена - пред.спот цена) / пред.спот цена * 100%]",
  sbd: "3x Long",
  sbs: "3x Short",
  flvjs:
    "Комиссия за финансирование ETF взимается ежедневно для покрытия издержек портфеля. Комиссия вычитается из NAV и взимается только в 00:00 (UTC+8). Хранение вне этого времени не облагается комиссией.",
  mzsm: "Отказ от ответственности",
  ido: "Я прочитал и принимаю",
  exemption1: "Уважаемый клиент!",
  exemption2:
    "Продолжая использовать ETF-продукты BiKing, вы подтверждаете, что понимаете риски и принимаете данные условия. Пожалуйста, ознакомьтесь:",
  exemption3: "«Руководство по ETF»",
  exemption4: "Предупреждение о рисках:",
  exemption5: "1. Отклонение цены покупки/продажи от NAV может привести к убытку.",
  exemption6: "2. При неверном прогнозе в экстремальных условиях цена может стремиться к нулю.",
  exemption7:
    "Все риски, связанные с ETF, ложатся на пользователя. BiKing не несёт ответственности. Данный документ является частью соглашения между BiKing и пользователем.",
  bzjs1: "1. «3L»: при росте базовой цены на 1% NAV растёт на 3%",
  bzjs2: "2. «3S»: при падении базовой цены на 1% NAV растёт на 3%",
  bzjs3: "3. NAV пересчитывается ежедневно в 0:00, при экстремальных движениях — в течение дня.",
  bzjs4: "4. Комиссия за плечо взимается ежедневно.",
  bzjs5:
    "5. Внимание: при экстремальном движении цена ETF может уйти далеко от NAV или стремиться к нулю. Контролируйте риск.",
  gdjk: "Подробнее в объявлениях",
  firstTrading: "Перед первой сделкой установите торговый пароль",
  status: "Статус",
  status1: "В ожидании",
  status2: "Не исполнен",
  status3: "Отменён пользователем",
  status4: "Частично исполнен",
  status5: "Полностью исполнен",
  status6: "Недействителен",
  allCancel: "Отменить выбранные ордера",
  canceld: "Отменить",
  cancelsuccess: "Отменено успешно ({cancelledCount} ордеров)",
  VIP1: "Ваш уровень VIP",
  VIP2: "Более низкие комиссии и лучший опыт",
  VIP3: "Taker:",
  VIP4: "Maker:",
  buyAmount: "Количество покупки не может превышать",
  sellAmount: "Количество продажи не может превышать",
  buyAmountMin: "Недостаточно средств для покупки",
  sellAmountMin: "Недостаточно средств для продажи",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/ru.js